module.exports = __webpack_public_path__ + "img/user2.92c031fe.jpg";